/* Femieko: favorite. Inimioarele [data-fe-fav] salvează produsul în localStorage („fe_fav_v1”: [{id, h, d}]),
   pe dispozitivul clientei. Pagina /pages/favorite (fe-favorite.js) citește aceeași listă.
   Starea se reaplică la încărcare, la carduri noi (MutationObserver), între file (storage) și la revenirea din cache (pageshow). */
(() => {
  if (window.FeFav) return;
  const KEY = 'fe_fav_v1';
  const MAX = 100;

  const read = () => {
    try {
      const a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter((x) => x && Number(x.id)) : [];
    } catch (e) {
      return [];
    }
  };
  const write = (a) => {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) { /* stocare indisponibilă */ }
  };

  let t = {};
  try { t = JSON.parse(document.getElementById('fe-fav-i18n').textContent); } catch (e) { t = {}; }

  const sync = (root) => {
    const ids = new Set(read().map((x) => Number(x.id)));
    (root || document).querySelectorAll('[data-fe-fav]').forEach((b) => {
      const on = ids.has(Number(b.dataset.id));
      if (b.getAttribute('aria-pressed') === String(on)) return;
      b.setAttribute('aria-pressed', String(on));
      b.classList.toggle('is-on', on);
      const label = on ? t.remove : t.add;
      if (label) { b.setAttribute('aria-label', label); b.title = label; }
    });
  };

  let toastEl;
  let toastTimer;
  const toast = (on) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fe-fav-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    const msg = on ? t.added : t.removed;
    if (!msg) return;
    toastEl.innerHTML = '';
    const span = document.createElement('span');
    span.textContent = msg;
    toastEl.appendChild(span);
    if (on && t.url && t.view) {
      const a = document.createElement('a');
      a.href = t.url;
      a.textContent = t.view;
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 3600);
  };

  const toggle = (id, handle, silent) => {
    id = Number(id);
    const a = read();
    const i = a.findIndex((x) => Number(x.id) === id);
    let on;
    if (i >= 0) { a.splice(i, 1); on = false; } else { a.unshift({ id, h: handle, d: Date.now() }); on = true; }
    write(a);
    sync();
    document.dispatchEvent(new CustomEvent('fe-fav:change', { detail: { id, on, list: a } }));
    if (!silent) toast(on);
    return on;
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-fe-fav]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (toggle(b.dataset.id, b.dataset.handle)) {
      b.classList.remove('is-pop');
      void b.offsetWidth;
      b.classList.add('is-pop');
    }
  }, true);

  window.addEventListener('storage', (e) => { if (e.key === KEY) sync(); });
  window.addEventListener('pageshow', () => sync());

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }).observe(document.body, { childList: true, subtree: true });

  window.FeFav = { KEY, read, write, toggle, sync };
  sync();
})();
